import { useCallback, useEffect } from 'react';
import { stringToBounds, useMap } from 'rwl-ui';
import { usePlacesAutocomplete } from '../../../hooks/usePlacesAutocomplete';
import { setHistoryState } from '../utils/setHistoryState';

const BOUND_URL_KEY = 'box';
const PLACEID_URL_KEY = 'placeID';

export const useMapParams = () => {
    const { bounds, fitBounds, clearBounds, isInitialized } = useMap();
    const { selectedPlaceDetails, setSelectedPlaceId } =
        usePlacesAutocomplete();

    const setStateFromUrl = useCallback(() => {
        const params = new URLSearchParams(window.location.search);

        // Update map to fit placeID or box, preferring placeID
        const placeID = params.get(PLACEID_URL_KEY);
        const box = params.get(BOUND_URL_KEY);
        if (placeID) {
            setSelectedPlaceId(placeID);
        } else if (box) {
            fitBounds(stringToBounds(box));
        } else {
            clearBounds();
        }
    }, []);

    // Set map bounds on page load
    useEffect(() => {
        if (isInitialized) {
            const params = new URLSearchParams(window.location.search);

            const placeID = params.get(PLACEID_URL_KEY);
            const box = params.get(BOUND_URL_KEY);
            if (placeID) {
                setSelectedPlaceId(placeID);
            } else if (box) {
                fitBounds(stringToBounds(box));
            }
        }
    }, [isInitialized]);

    // Update the map bounds on back/forward
    useEffect(() => {
        window.addEventListener('popstate', setStateFromUrl);
        return () => {
            window.removeEventListener('popstate', setStateFromUrl);
        };
    }, [setStateFromUrl]);

    // When bounds change update the URL
    useEffect(() => {
        if (isInitialized) {
            const searchParams = new URLSearchParams(window.location.search);
            const { place_id } = selectedPlaceDetails || {};
            if (place_id) {
                searchParams.set(PLACEID_URL_KEY, place_id);
                searchParams.delete(BOUND_URL_KEY);
            } else if (bounds) {
                searchParams.set(BOUND_URL_KEY, bounds);
                searchParams.delete(PLACEID_URL_KEY);
            } else {
                searchParams.delete(BOUND_URL_KEY);
                searchParams.delete(PLACEID_URL_KEY);
            }

            setHistoryState(searchParams, 'replace');
        }
    }, [selectedPlaceDetails, bounds, isInitialized]);
};
